import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { zeitraumGuard } from './guards/zeitraum.guard';
import { RohstoffbilanzRepository } from './repositories/rohstoffbilanz.repository';
import { RohstoffbilanzService } from './services/rohstoffbilanz.service';
import { RohstoffbilanzDetailRepository } from './repositories/detail.repository';
import { RohstoffbilanzDetailService } from './services/detail.service';

export const rohstoffbilanzRoutes: Routes = [
  {
    path: 'rohstoffbilanz',
    providers: [
      RohstoffbilanzRepository,
      RohstoffbilanzService,

      RohstoffbilanzDetailRepository,
      RohstoffbilanzDetailService,
    ],
    loadComponent: () => import('./pages/rohstoffbilanz.component'),
    children: [
      {
        path: 'zeitraum-eingabe',
        loadComponent: () => import('./pages/zeitraumeingabe/zeitraumeingabe.component'),
      },
      {
        path: '',
        loadComponent: () => import('./pages/dashboard/dashboard.component'),
        canActivate: [zeitraumGuard],
      },
      {
        path: '**',
        redirectTo: '/rohstoffbilanz/zeitraum-eingabe',
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    // data: { permission: SOFTLINE_PERMISSION_ROHSTOFFBILANZ }
  },
];
